import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button, Table, TableHead, TableRow, TableCell, TableBody, Chip, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { loadHeldBills, removeHeldBill } from '../utils/holdBills';

export default function HoldBills() {
  const [bills, setBills] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setBills(loadHeldBills());
  }, []);

  const refresh = () => setBills(loadHeldBills());

  const handleResume = (id) => {
    navigate('/pos', { state: { holdId: id } });
  };

  const handleDelete = (id) => {
    removeHeldBill(id);
    refresh();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, fontSize: '1rem' }}>
        Held Bills
      </Typography>

      <Paper sx={{ p: 2, border: '1px solid', borderColor: 'divider', boxShadow: 1 }}>
        {(!bills || bills.length === 0) ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              No held bills yet. Create one from the POS screen using Hold Bill.
            </Typography>
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => navigate('/pos')}>
              Go to POS
            </Button>
          </Box>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', py: 0.75, color: 'text.primary', borderBottom: '2px solid', borderColor: 'divider' }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', py: 0.75, color: 'text.primary', borderBottom: '2px solid', borderColor: 'divider' }}>Items</TableCell>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', py: 0.75, color: 'text.primary', borderBottom: '2px solid', borderColor: 'divider' }}>Total</TableCell>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', py: 0.75, color: 'text.primary', borderBottom: '2px solid', borderColor: 'divider' }}>Created</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600, fontSize: '0.75rem', py: 0.75, color: 'text.primary', borderBottom: '2px solid', borderColor: 'divider' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bills.map((bill) => (
                <TableRow key={bill.id} sx={{ 
                  '&:hover': { bgcolor: 'action.hover' },
                  '& .MuiTableCell-root': {
                    py: 0.75,
                    px: 1.5,
                    fontSize: '0.8rem'
                  }
                }}>
                  <TableCell>
                    <Stack direction="column" spacing={0.5}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{bill.name}</Typography>
                      <Typography variant="caption" color="text.secondary">ID: {bill.id}</Typography>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Chip label={`${bill.totals?.itemCount || 0} items`} size="small" />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>₹{bill.totals?.payable?.toFixed ? bill.totals.payable.toFixed(2) : bill.totals?.payable || 0}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption" color="text.secondary">
                      {bill.createdAt ? new Date(bill.createdAt).toLocaleString() : '—'}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button variant="outlined" size="small" onClick={() => handleResume(bill.id)}>
                        Resume
                      </Button>
                      <Button variant="text" color="error" size="small" onClick={() => handleDelete(bill.id)}>
                        Delete
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Box>
  );
}
